export const GET_CANDIDATE_ASSESSMENT_STATUS = "GET_CANDIDATE_ASSESSMENT_STATUS"
export const GET_CANDIDATE_ASSESSMENT_STATUS_SUCCESS = "GET_CANDIDATE_ASSESSMENT_STATUS_SUCCESS"
export const GET_CANDIDATE_ASSESSMENT_STATUS_ERROR = "GET_CANDIDATE_ASSESSMENT_STATUS_ERROR"

export const GET_CANDIDATE_ASSESSMENT_OVERRIDE = "GET_CANDIDATE_ASSESSMENT_OVERRIDE"
export const GET_CANDIDATE_ASSESSMENT_OVERRIDE_SUCCESS = "GET_CANDIDATE_ASSESSMENT_OVERRIDE_SUCCESS"
export const GET_CANDIDATE_ASSESSMENT_OVERRIDE_ERROR="GET_CANDIDATE_ASSESSMENT_OVERRIDE_ERROR"
